var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 9.99992C1.66699 6.85722 1.66699 5.28587 2.6433 4.30956C3.61961 3.33325 5.19096 3.33325 8.33366 3.33325H11.667C14.8097 3.33325 16.381 3.33325 17.3573 4.30956C18.3337 5.28587 18.3337 6.85722 18.3337 9.99992V11.6666C18.3337 14.8093 18.3337 16.3806 17.3573 17.3569C16.381 18.3333 14.8097 18.3333 11.667 18.3333H8.33366C5.19096 18.3333 3.61961 18.3333 2.6433 17.3569C1.66699 16.3806 1.66699 14.8093 1.66699 11.6666V9.99992Z",
    stroke: "#DC143C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 3.33325V2.08325",
    stroke: "#DC143C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 3.33325V2.08325",
    stroke: "#DC143C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 7.5H17.9163",
    stroke: "#DC143C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 14.1667C14.9997 14.6269 14.6266 15 14.1663 15C13.7061 15 13.333 14.6269 13.333 14.1667C13.333 13.7064 13.7061 13.3333 14.1663 13.3333C14.6266 13.3333 14.9997 13.7064 14.9997 14.1667Z",
    fill: "#DC143C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 10.8333C14.9997 11.2936 14.6266 11.6667 14.1663 11.6667C13.7061 11.6667 13.333 11.2936 13.333 10.8333C13.333 10.3731 13.7061 10 14.1663 10C14.6266 10 14.9997 10.3731 14.9997 10.8333Z",
    fill: "#DC143C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 14.1667C10.8337 14.6269 10.4606 15 10.0003 15C9.54009 15 9.16699 14.6269 9.16699 14.1667C9.16699 13.7064 9.54009 13.3333 10.0003 13.3333C10.4606 13.3333 10.8337 13.7064 10.8337 14.1667Z",
    fill: "#DC143C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 10.8333C10.8337 11.2936 10.4606 11.6667 10.0003 11.6667C9.54009 11.6667 9.16699 11.2936 9.16699 10.8333C9.16699 10.3731 9.54009 10 10.0003 10C10.4606 10 10.8337 10.3731 10.8337 10.8333Z",
    fill: "#DC143C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 14.1667C6.66667 14.6269 6.29357 15 5.83333 15C5.3731 15 5 14.6269 5 14.1667C5 13.7064 5.3731 13.3333 5.83333 13.3333C6.29357 13.3333 6.66667 13.7064 6.66667 14.1667Z",
    fill: "#DC143C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 10.8333C6.66667 11.2936 6.29357 11.6667 5.83333 11.6667C5.3731 11.6667 5 11.2936 5 10.8333C5 10.3731 5.3731 10 5.83333 10C6.29357 10 6.66667 10.3731 6.66667 10.8333Z",
    fill: "#DC143C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c63eca975ce7eeda7f1438cdbe48154b.svg";
export { ForwardRef as ReactComponent };